import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'app-ask-forum',
  templateUrl: './ask-forum.component.html',
  styleUrls: ['./ask-forum.component.scss'],
})
export class AskForumComponent implements OnInit {
  @ViewChild('detailPost', { static: true }) detailPost: TemplateRef<any>;
  @ViewChild('forumForm', { static: true }) forumForm: TemplateRef<any>;
  @Input() ask: any = {};

  openTag: boolean = false;
  openAll: boolean = false;
  constructor(
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private clipboard: Clipboard
  ) { }

  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;


  detailForum: any = {
    replyText: '',
  };
  showMessageBoxReply: boolean = false;
  imgUrl: string = environment.ImageUrl;

  ngOnInit() {
    const getUser = this.local.getUser();

    if (getUser) {
      this.appUserId = getUser.id;
    }

    getUser ? (this.isLogin = 1) : 0;
    this.isLoading = true;
    this.detailForum = this.ask;
    this.initReply(this.ask.id);
  }

  ngOnDestroy(): void {
    // Clear all intervals
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';
  isModerator = () =>
    this.local.getUser()?.role == 'moderator' || this.isAdmin();
  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;

    if (this.isAdmin()) {
      return user.id == data.createdBy && data.isAdmin;
    } else {
      return user.id == data.createdBy && !data.isAdmin;
    }
  };

  // getPages = () => this.local.getPages(this.forums.currentPage, this.forums.lastPage);

  onEditorChange = (event: any) =>
    (this.detailForum.replyText = event.editor.getData());

  scrollTo(id: string) {
    this.local.scrollTo(id);
  }

  formatDate(value: any) {
    return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
  }

  loginHere() {
    this.modalService.dismissAll();
    document.getElementById('loginBtn').click();
  }

  initReply(id: number) {
    this.auth
      .marketplace_forum_shop_fetch_reply(id, 1, true, true)
      .subscribe((response: any) => {
        // this.shopForum.list[index].replies = response.body
        // this.shopForum.list[index].replies.map((row: any) => {
        //   row.user = row.user ?? {}
        //   row.createdAt = new Date(row.createdAt * 1000).toLocaleString()
        // })
        this.detailForum.replies = response.body;
      });
  }

  openDetailPost(item: any) {
    // this.modalService.dismissAll()
    // this.modalRef = this.modalService.open(modal, { size: 'sm', backdrop: 'static', ariaLabelledBy: 'modal-basic-title', windowClass: 'forum_detail_post' })
  
    this.detailForum = item;
    this.detailForum.images = JSON.parse(this.detailForum.images);
    this.initReply(item.id);
  }

  async handleShowOptionForumReply(index: number) {
    await Promise.all(
      this.detailForum?.replies.map((row: any, i: number) => {
        if (index != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.detailForum.replies[index].showOption =
        !this.detailForum.replies[index].showOption;
    });
  }
  async handleShowOptionForumReplyChild(item: any) {
    item.showOption = !item.showOption;
  }

  storeForumMessageReply(id: number = null, item: any = null) {
    const forum = item != null ? item : this.detailForum;
    const isChild = item != null;
    if (forum.replyText?.length < 1 && id == null) {
      return this.toastr.error('Please Fill a Message !');
    }

    this.detailForum.hasSubmit = true;
    const parentChild = isChild ? forum.id : null;

    if (id != null) {
      forum.replyText = forum.messageEdit;
    }

    const form = {
      askId: isChild ? forum.askId : forum.id,
      message: forum.replyText,
      createdBy: this.appUserId,
      id: id,
      isAdmin: this.isAdmin(),
      isChild: isChild,
      parentChild: parentChild,
    };

    this.auth.marketplace_forum_shop_store_reply(form).subscribe(
      () => {
        this.detailForum.hasSubmit = false;
        this.toastr.success('The message was successfully added');

        this.initReply(this.detailForum.id);
        this.showMessageBoxReply = false;
        forum.replyText = '';
      },
      () => {
        this.toastr.error('Message failed to add');
        this.detailForum.hasSubmit = false;
      }
    );
  }

  storeForumMessageEdit(item: any) {
    this.storeForumMessageReply(item.id, item);
  }

  editForumMessage(event: any, item: any) {
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;

  }

  editForumMessageReply(event: any, item: any) {
    event.preventDefault();
    item.isEdit = !item.isEdit;
    item.messageEdit = item.message;
    item.showOption = false;

  }

  deleteForumMessageReply(event: any, id: any, index: number = null) {
    event.preventDefault();
    this.local.alertConfirm({}).then((resp) => {
      if (resp.isConfirmed) {
        this.local.alertLoading({});
        try {
          this.auth.marketplace_forum_shop_delete_reply(id).subscribe(() => {
            this.local.alertSuccess({}).then(() => {
              this.initReply(this.detailForum.id);
            });
          });
        } catch (e) {
          this.local.alertInternalError();
        }
      }
    });
  }

  showReplyMessageBox(event: any, item: any) {
    event.preventDefault();
    item.showReplyBox = !item.showReplyBox;

  }

  copyLink(type: string, item: any) {
    let currentUrl = window.location.href.split('#')[0];
    currentUrl = currentUrl + '#/forum';
    this.clipboard.copy(`${currentUrl}?type=${type}&uuid=${item.uuid}`);
    this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
  }

  handleReport(id: any, category = 'ask') {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: category,
            product_id: id,
          })
          .subscribe(
            () => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }
}
